"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fetch = _interopRequireDefault(require("./fetch"));

var _graphql = _interopRequireDefault(require("./graphql"));

var _internal = _interopRequireDefault(require("../internal"));

var _lazyMetrics = _interopRequireWildcard(require("../metrics/lazyMetrics"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//invoked on every configure event
function configure(config) {
  _internal.default.configureNetwork(config);

  const metrics = new _lazyMetrics.default('exc.module-runtime');
  metrics.event('Runtime.deprecationWarnings', 'Configure is deprecated.', {
    level: _lazyMetrics.Level.WARN
  });
}

const network = {
  configure,
  fetch: _fetch.default.fetch,
  query: _graphql.default.query
};
var _default = network;
exports.default = _default;